import { motion } from "framer-motion";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Sofia M.",
    location: "Ciudad de Mexico",
    text: "Serena transformo mis noches. Encender la vela y seguir el ritual digital se convirtio en mi momento sagrado del dia.",
    rating: 5,
  },
  {
    name: "Valentina R.",
    location: "Guadalajara",
    text: "Las afirmaciones son hermosas y el audio ambiental es perfecto. No sabia que una vela podia ofrecer tanto.",
    rating: 5,
  },
  {
    name: "Camila L.",
    location: "Monterrey",
    text: "La regale a mi mama y ahora las dos hacemos nuestro ritual juntas por video. Serena nos conecto de una forma especial.",
    rating: 5,
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export default function TestimonialsSection() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      {/* Divider line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-20 bg-gradient-to-b from-transparent to-[#D4AF37]/20" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
          className="text-center mb-16"
        >
          <motion.p variants={fadeUp} className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80 mb-4">
            Comunidad
          </motion.p>
          <motion.h2
            variants={fadeUp}
            className="font-serif text-4xl md:text-5xl font-normal tracking-tight leading-tight text-white"
            data-testid="testimonials-heading"
          >
            Lo que dicen de
            <span className="italic text-[#D4AF37]"> Serena</span>
          </motion.h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={{ visible: { transition: { staggerChildren: 0.15 } } }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              variants={fadeUp}
              className="bg-white/[0.03] backdrop-blur-sm border border-white/[0.06] p-8 hover:border-[#D4AF37]/20 transition-colors duration-500"
              data-testid={`testimonial-card-${i}`}
            >
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <Star
                    key={j}
                    size={14}
                    className="fill-[#D4AF37] text-[#D4AF37]"
                  />
                ))}
              </div>
              <p className="text-sm text-white/60 leading-relaxed mb-6 italic font-serif">
                "{t.text}"
              </p>
              <div>
                <p className="text-sm font-semibold text-white">{t.name}</p>
                <p className="text-xs text-white/30">{t.location}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
